import { render, staticRenderFns } from "./CmgNewHero.vue?vue&type=template&id=3aea9fbe&scoped=true&lang=pug&"
import script from "./cmg-new-hero.ts?vue&type=script&lang=ts&"
export * from "./cmg-new-hero.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNewHero.vue?vue&type=style&index=0&id=3aea9fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea9fbe",
  null
  
)

export default component.exports